import {
    IStatePointResult, IBaseStatePoint,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';

export default class BaseStatePoint implements IBaseStatePoint {
    protected completeResolve: (value: IStatePointResult) => void;
    private completePromise: Promise<IStatePointResult> = new Promise(resolve => this.completeResolve = resolve);
    private firstTime: number | null = null;

    public get isCompleted(): boolean {
        return !!this.firstTime;
    }

    public getPointCompletePromise(): Promise<IStatePointResult> {
        return this.completePromise;
    }

    protected emitPointComplete(params: IStatePointResult): boolean {
        if (!this.firstTime) {
            this.firstTime = params.time;
            return true;
        }
        return false;
    }
}
